let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jt89L")).then(() => parcelRequire('6jZlH'));